import QuizApp from './components/QuizApp';
import './index.css';

function App() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <QuizApp />
    </div>
  );
}

export default App;